import axios from "axios";

import baseUrl from "../../services/api";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

const Login = () => {
  function setCookie(name, value, days) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);

    const cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
    document.cookie = cookie;
  }

  const navigate = useNavigate();


  const [role, setRole] = useState("");

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const changeHandlerUserName = (e) => {
    setUserName(e.target.value);
    console.log(userName);
  };
  const toggleRememberMe = () => {
    setRememberMe(!rememberMe);
  };
  const changeHandlerPassword = (e) => {
    setPassword(e.target.value);
  };

  const checkUser = (e) => {
    const dat = {
      email: userName,
      password: password,
    };
    console.log("kkkkk");
    console.log(dat);

    try {
      axios
        .post(`${baseUrl}/login `, dat)

        .then((response) => {
          console.log(response.data);
          setError(response.data.message);

          sessionStorage.setItem(
            "name",
            response.data.firstName + " " + response.data.lastName
          );
          sessionStorage.setItem("login", "1");
          sessionStorage.setItem("email", response.data.email);
          sessionStorage.setItem("user_id", response.data.id);
          sessionStorage.setItem("token", response.data.token);
          sessionStorage.setItem("com_id", response.data.companyid);
          sessionStorage.setItem("form_type", response.data.type);
          
          axios.defaults.headers.common = {
            Authorization: `Bearer ${response.data.token}`,
          };
          if (rememberMe) {
            // Save login status and email in cookies for a persistent login
            setCookie("login", response.data.email, 30); // Expires in 30 days
          }
          if (response.data.RoleAdmin) {
            
         
            sessionStorage.setItem("role", "admin");
            navigate("/member");
            // navigate("/adminPage", { state: response.data });
          } else if (response.data.RoleUser) {
           
            sessionStorage.setItem("role", "user");
            navigate("/form");
          } else if (response.data.RoleSuperAdmin) {
          
            sessionStorage.setItem("role", "super");
            navigate("/company");
          }

         
        })
        .catch((err) => {
          setError("Username or Password Error");
          console.error(err);
        });
      e.preventDefaulte();
    } catch (error) {
      if (error.message === "Network Error") {
        setError("No internet connection");
      }
    }
  };

  return (
    <div className="lbg">
      <Row>
       
        <Col md='6' className="new-login-design">
          <form className="loginform">
            <div className="mb-3">
              <label>Email</label>
              <input
                type="text"
                name="username"
                required
                className="form-control"
                placeholder="Enter username"
                onChange={changeHandlerUserName}
              />
            </div>
            <div className="mb-3">
              <label>Password</label>
              <input
                type="password"
                name="password"
                required
                className="form-control"
                placeholder="Enter password"
                onChange={changeHandlerPassword}
              />
            </div>
            <div className="mb-3">
              <div className="custom-control custom-checkbox">
                <Row>
                  <Col>
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customCheck1"
                      checked={rememberMe}
                      onChange={toggleRememberMe}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customCheck1">
                      <span className="rember-me"> Remember me</span>
                    </label>
                  </Col>
                  <Col>
                    <Link>
                      {" "}
                      <span className="rember-me"> Forgot Password</span>
                    </Link>
                  </Col>
                </Row>

                <center className="errormessage">{error}</center>
              </div>
            </div>
            <div className="d-grid">
              <div onClick={checkUser} className="btn btn-primary">
                Submit
              </div>
            </div>
          </form>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
